import React from "react";


const Experience = ()=>{
    return(
        <div className="experience">
            <h3>Expérience</h3>
            <div className="exp-1">
                <h4>Détenteur d'un diplôme d'état</h4>
                <h5>2018-2019</h5>
                <p>Lorem ipsum dolor sit amat consectur, Lorem ipsum dolor sit amat consectur,Lorem ipsum dolor sit amat consectur,
                Lorem ipsum dolor sit amat consectur,Lorem ipsum dolor sit amat consectur, </p>
            </div>
            <div className="exp-2">
                <h4>Stage Academique chez Avenir Business</h4>
                <h5>2020-2021</h5>
                <p>Lorem ipsum dolor sit amat consectur, Lorem ipsum dolor sit amat consectur,Lorem ipsum dolor sit amat consectur,
                Lorem ipsum dolor sit amat consectur,Lorem ipsum dolor sit amat consectur, </p>
            </div>
            <div className="exp-3">
                <h4>Licencié en dévenir</h4>
                <h5>2021-2022</h5>
                <p>Lorem ipsum dolor sit amat consectur, Lorem ipsum dolor sit amat consectur,Lorem ipsum dolor sit amat consectur,
                Lorem ipsum dolor sit amat consectur,Lorem ipsum dolor sit amat consectur, </p>
            </div>
        </div>
    )
}

export default Experience;